import { getCO2AequivalentSubscope49, getCO2AequivalentSubscope6_Entfernung, getCO2AequivalentSubscope6_Uebernachtung, getCO2AequivalentSubscope69_Unterkunft } from '../getCO2Aequivalent';
import { getDataForKraftstoff } from './getDataForKraftstoff';
import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { IDs } from '../../../helpers/IDs';
import { getDatenqualitaet } from '../getDatenqualitaet';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';

export function processSubscope49(row: any, data: any, item: any, jahr: number, arr: any[], subscope: number) {
    if (row.parent_tid && row.parent_tid > 0) {
        return; // Das ist eine Entfernungs-Row, also raus
    }
    const entity = subscope === 4 ? IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT : IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT;
    row = { ...row };
    if (subscope === 4 && (row.art === 'mobilitaet' || row.art_orig === 'mobilitaet')) {
        processSubscope4mobil(row, data, item, jahr, arr);
        return;
    }
    // Konfig
    const konfData: any[] = data[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
    const isMobilitaet = co2_fussabdruck_ghg && +subscope === 9 && row.art === 'mobilitaet';
    const modus = row.modus;
    row.name = (row.lieferant_tid ? row.lieferant_tid : row.bemerkung);
    // console.log('SS' + subscope, isMobilitaet, co2_fussabdruck_ghg, modus, row, arr);
    const key_wert = `co2_fussabdruck_s3_ss${subscope}_wert`;
    let faktor = null;
    let gewicht = row.menge;
    const subrows = arr.filter((sr: any) => sr.parent_tid === row.tid && sr.modus === modus);
    const arr_datenqualitaet: any[] = [];

    if (!co2_fussabdruck_ghg || !modus || modus === 0 || modus === 'distance_based') {
        const faktor_person = isMobilitaet ? row.personen ? row.personen : 1 : 1;
        const fakt_hin_rueck = !isMobilitaet ? 1 : (+row.hin_rueck === 2 || +row.hin_rueck_orig === 2) ? 1 : 2;
        let entfernung = 0;
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            // Transport mit Teilstrecken
            const names: any = {};
            subrows.forEach((sr: any) => {
                const faktor_entf = getCO2AequivalentSubscope49(data, jahr, sr.transportmittel, entity, 'transportmittel');
                let faktor_wert, faktor_quelle, value_entf;
                if (isMobilitaet) {
                    faktor_wert = +faktor_entf.wert_person;
                    faktor_quelle = faktor_entf.quelle_person;
                    value_entf = +sr.entfernung * fakt_hin_rueck * faktor_person * faktor_wert;
                } else {
                    faktor_wert = faktor_entf.wert;
                    faktor_quelle = faktor_entf.quelle;
                    value_entf = +sr.entfernung * gewicht * faktor_wert;
                }
                if (!row.quelle) {
                    row.quelle = faktor_quelle;
                } else if (row.quelle.indexOf(faktor_quelle) === -1) {
                    row.quelle += ';;' + faktor_quelle;
                }
                if (row.value) {
                    row.value += value_entf;
                } else {
                    row.value = value_entf;
                }
                entfernung += sr.entfernung;
                let subname;
                if (sr.transportmittel) {
                    subname = getStaticOption(entity, 'transportmittel', sr.transportmittel);
                    names[subname] = true;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                let faktor: any;
                if (isMobilitaet) {
                    faktor = {
                        info: subname,
                        menge: sr.entfernung,
                        menge_einheit: 'km',
                        menge_einheitOrig: 'km',
                        wert: faktor_entf.wert_person * 1000000,
                        quelle: faktor_entf.quelle_person,
                        einheit: 'gCO₂Äq/km',
                        wert_um: fakt_hin_rueck,
                        quelle_um: 'Faktor Hin- und Rückfahrt',
                        wert_um_co2: fakt_hin_rueck * faktor_person,
                        quelle_um_co2: 'Faktor Hin- und Rückfahrt × Personen'
                    };
                } else {
                    faktor = {
                        info: subname,
                        menge: sr.entfernung,
                        menge_einheit: 'tkm',
                        menge_einheitOrig: 'km',
                        wert: faktor_entf.wert * 1000000,
                        quelle: faktor_entf.quelle,
                        einheit: 'gCO₂Äq/tkm',
                        wert_um: gewicht,
                        einheit_um: 't',
                        quelle_um: 'Warengewicht [Tonnen]',
                        wert_um_co2: gewicht,
                        einheit_um_co2: 't',
                        quelle_um_co2: 'Warengewicht [Tonnen]',
                        formel_um: 'menge_strecke_gewicht',
                        formel_co2: 'co2_strecke_gewicht',
                        faktor_um_info: 'Gewicht'
                    };
                }
                row.faktor_map[faktor_entf.info] = faktor;
                if(faktor_entf && ((isMobilitaet && (faktor_entf.datenqualitaet_person || faktor_entf.datenqualitaet_person === 0)) ||
                                   (!isMobilitaet && (faktor_entf.datenqualitaet_tonnen || faktor_entf.datenqualitaet_tonnen === 0)))
                ) {
                    arr_datenqualitaet.push({
                        // wert: isMobilitaet ? +sr.personen : +sr.entfernung,
                        wert: value_entf === 0 ? 0.1 : value_entf, // hier Emission t CO2 Äq.
                        emissionsfaktor: isMobilitaet ? +faktor_entf.datenqualitaet_person : +faktor_entf.datenqualitaet_tonnen,
                        bewertung: +row.bewertung_emissionsfaktor,
                        datenherkunft: +row.datenherkunft
                    });
                }
            });
            row.name = Object.keys(names).join('\n');
            row.faktor_einheit = 'gemischt';
            if (isMobilitaet) {
                row.menge = entfernung * fakt_hin_rueck;
                row.einheit = 'km';
            } else {
                row.menge = entfernung * gewicht;
                row.einheit = 'tkm';
            }
        } else if (row.transportmittel === 'uebernachtung') {
            // Unterkunft
            row.faktor_einheit = 'gCO₂Äq/Ün';
        } else {
            // Transport ohne Teilstrecken
            if (!faktor) {
                faktor = getCO2AequivalentSubscope49(data, jahr, row.transportmittel, entity, 'transportmittel');
            }
            if (faktor.invalid || !row.entfernung) {
                return;
            }
            let faktor_wert, faktor_quelle;
            if (isMobilitaet) {
                faktor_wert = +faktor.wert_person;
                faktor_quelle = faktor.quelle_person;
            } else {
                faktor_wert = +faktor.wert;
                faktor_quelle = faktor.quelle;
            }
            row.name = getStaticOption(entity, 'transportmittel', row.transportmittel);
            row.quelle = faktor_quelle;
            row.faktor = faktor_wert * 1000000;
            if (isMobilitaet) {
                row.menge = row.entfernung * fakt_hin_rueck * faktor_person;
                row.einheit = 'km';
                row.mengeOrig = row.entfernung;
                row.einheitOrig = 'km';
                row.value = row.menge * faktor_wert;
                row.faktor_einheit = 'gCO₂Äq/km';
                row.formel_co2 = 'co2_fahrt_personen';
                row.faktoren = [
                    {
                        value: fakt_hin_rueck,
                        type: KennzahlFaktor.TYPE_FAHRT,
                        formel: 'menge_fahrt'
                    },
                    {
                        value: faktor_person,
                        type: KennzahlFaktor.TYPE_PERSONEN,
                        formel: 'menge_fahrt_personen'
                    }
                ];
            } else {
                row.menge = row.entfernung * gewicht;
                row.einheit = 'tkm';
                row.mengeOrig = row.entfernung;
                row.einheitOrig = 'km';
                row.value = row.entfernung * gewicht * faktor_wert;
                row.faktor_einheit = 'gCO₂Äq/tkm';
                row.faktoren = [
                    {
                        value: gewicht,
                        type: KennzahlFaktor.TYPE_GEWICHT,
                        quelle: 'Warengewicht [Tonnen]',
                        einheit: 't',
                        formel: 'menge_strecke_gewicht',
                        formel_co2: 'co2_strecke_gewicht'
                    }
                ];
            }
            if (!row.value || row.value === 0) {
                return;
            }
            if(faktor && ((isMobilitaet && (faktor.datenqualitaet_person || faktor.datenqualitaet_person === 0)) ||
                                   (!isMobilitaet && (faktor.datenqualitaet_tonnen || faktor.datenqualitaet_tonnen === 0)))
                ) {
                arr_datenqualitaet.push({
                    // wert: +row.menge,
                    wert: row.value === 0 ? 0.1 : row.value, // hier Emission t CO2 Äq.
                    emissionsfaktor: isMobilitaet ? +faktor.datenqualitaet_person : +faktor.datenqualitaet_tonnen,
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.bewertung_emissionsfaktor
                });
            }
        }
    } else if (modus === 'spend_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            subrows.forEach((sr: any) => {
                const faktor_spend = getCO2AequivalentSubscope49(data, jahr, sr.transportmittel, entity, 'transportmittel');
                const value_spend = +sr.kosten * faktor_spend.wert_euro;
                if (row.value) {
                    row.value += value_spend; // * +row.menge;
                    row.kosten += +sr.kosten;
                } else {
                    row.value = value_spend; // * +row.menge;
                    row.kosten = +sr.kosten;
                }
                let subname;
                if (sr.transportmittel) {
                    subname = getStaticOption(entity, 'transportmittel', sr.transportmittel);
                    names[subname] = true;
                }
                if (!row.quelle) {
                    row.quelle = faktor_spend.quelle;
                } else if (row.quelle.indexOf(faktor_spend.quelle) === -1) {
                    row.quelle += ';;' + faktor_spend.quelle;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                let faktor: any;
                if (isMobilitaet) {

                } else {
                    faktor = {
                        info: subname,
                        menge: sr.kosten,
                        wert: faktor_spend.wert_euro * 1000000,
                        quelle: faktor_spend.quelle,
                        einheit: 'gCO₂Äq/€'
                    };
                }
                row.faktor_map[sr.transportmittel] = faktor;
                arr_datenqualitaet.push({
                    // wert: +sr.kosten,
                    wert: value_spend, // hier Emission t CO2 Äq.
                    emissionsfaktor: +faktor_spend.datenqualitaet_kosten,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft
                });

            });
            row.menge = row.kosten;
            // row.faktor = (row.value / row.kosten) * 1000000;
            row.faktor_einheit = 'gemischt';
            row.einheit = '€';
            row.name = Object.keys(names).join('\n');
        } else {
            faktor = getCO2AequivalentSubscope49(data, jahr, row.transportmittel, entity, 'transportmittel');
            // console.log('S49SB:', faktor, row);
            const value = (faktor.wert_euro || 0) * +row.kosten;
            row.value = value;
            row.name = getStaticOption(entity, 'transportmittel', row.transportmittel);
            row.quelle = faktor.quelle_euro;
            row.menge = row.kosten;
            row.einheit = '€';
            if (!row.uebernachtungen_anzahl) {
                row.faktor = faktor.wert_euro * 1000000;
                row.faktor_einheit = 'gCO₂Äq/€';
                row.quelle = faktor.quelle_euro;
            } else {
                row.faktor_einheit = 'gemischt';
            }

            arr_datenqualitaet.push({
                // wert: +row.menge,
                wert: value, // hier Emission t CO2 Äq.
                emissionsfaktor: +faktor.datenqualitaet_kosten,
                datenherkunft: +row.datenherkunft,
                bewertung: +row.bewertung_emissionsfaktor
            });
        }
    } else if (modus === 'fuel_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            let menge = 0;
            let value = 0;
            subrows.forEach((sr: any) => {
                const fuel_item = getDataForKraftstoff(sr, jahr, data);
                if (row.verbrauch) {
                    row.verbrauch += sr.verbrauch;
                    row.value += fuel_item.co2;
                } else {
                    row.verbrauch = sr.verbrauch;
                    row.value = fuel_item.co2;
                }
                names[sr.energietraeger_tid] = true;
                if (!row.quelle) {
                    row.quelle = fuel_item.quelle;
                } else if (row.quelle.indexOf(fuel_item.quelle) === -1) {
                    row.quelle += ';;' + fuel_item.quelle;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                row.faktor_map[fuel_item.energietraeger] = {
                    info: sr.energietraeger_tid,
                    menge: +sr.verbrauch,
                    menge_einheit: 'kWh',
                    menge_einheitOrig: fuel_item.einheit,
                    wert: fuel_item.faktor_co2 * 1000000,
                    quelle: fuel_item.quelle_co2,
                    einheit: 'gCO₂Äq/kWh',
                    wert_um: fuel_item.faktor_um,
                    einheit_um: `kWh/${fuel_item.einheit}`,
                    quelle_um: fuel_item.quelle_um,
                    wert_um_co2: fuel_item.faktor_um,
                    einheit_um_co2: `kWh/${fuel_item.einheit}`,
                    quelle_um_co2: fuel_item.quelle_um,
                };
                arr_datenqualitaet.push({
                    // wert: +sr.verbrauch,
                    wert: fuel_item.co2, // hier Emission t CO2 Äq.
                    emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.bewertung_emissionsfaktor
                });
                menge += sr.verbrauch * fuel_item.faktor_um;
                value += sr.verbrauch * fuel_item.faktor_um * fuel_item.faktor_co2;
            });
            row.name = Object.keys(names).join('\n');
            row.faktor_einheit = 'gCO₂Äq/kWh';
            row.menge = menge;
            row.value = value;
            row.einheit = 'kWh';
        } else {
            const fuel_item = getDataForKraftstoff(row, jahr, data);
            row.name = row.energietraeger_tid;
            row.value = fuel_item.co2;
            row.menge = row.verbrauch * fuel_item.faktor_um;
            row.einheit = 'kWh';
            row.mengeOrig = row.verbrauch;
            row.einheitOrig = fuel_item.einheit;
            row.faktor = fuel_item.faktor_co2 * 1000000;
            row.faktor_einheit = 'gCO₂Äq/kWh';
            row.quelle = fuel_item.quelle_co2;
            if(fuel_item.faktor_um && +fuel_item.faktor_um !== 1) {
                row.mengeShow = row.mengeOrig;
                row.einheitShow = row.einheitOrig;
                row.faktor_show = fuel_item.faktor_co2 * 1000000 * fuel_item.faktor_um;
                row.faktor_einheit_show = 'gCO₂Äq/' + row.einheitOrig;
            }
            row.formel_co2 = 'umrechnung_co2';
            row.faktoren = [
                {
                    info: `Umrechnung ${fuel_item.einheit}`,
                    value: fuel_item.faktor_um,
                    type: KennzahlFaktor.TYPE_UMRECHNUNG,
                    quelle: fuel_item.quelle_um,
                    einheit: `kWh/${fuel_item.einheit}`,
                    formel: 'verbrauch_umrechnung'
                }
            ];
            arr_datenqualitaet.push({
                // wert: +row.menge,
                wert: fuel_item.co2,
                emissionsfaktor: +fuel_item.datenqualitaet_1,
                datenherkunft: +row.datenherkunft,
                bewertung: +row.bewertung_emissionsfaktor
            });
        }
    } else if (modus === 'user_specific') {
        row.name = row.name_nutzer;
        row.menge = row.menge_nutzer;
        row.einheit = row.einheit_nutzer;
        row.value = row.menge_nutzer && row.faktor_nutzer ? row.faktor_nutzer * row.menge_nutzer : row.menge_nutzer;
        row.faktor = row.faktor_nutzer ? row.faktor_nutzer * 1000000 : null;
        row.faktor_einheit = `gCO₂Äq/${row.einheit_nutzer || ''}`;
        row.quelle = `Eingabe durch Nutzer:in${row.quelle_nutzer ? ` / Quelle: ${row.quelle_nutzer}` : ''}`;

        arr_datenqualitaet.push({
            // wert: +row.menge,
            wert: row.value,
            emissionsfaktor: +row.datenqualitaet_emissionsfaktor,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
    } else if (modus === 'none') {
        // if (row.tid === -999) {
        if ((row.tid + '').startsWith('kampagne_')) {
            // Datensätze aus Kampagnen
            if (row.uebernachtungen_orig === 1 && row.unterkunft && row.uebernachtungen_anzahl > 0) {
                // Unterkunft
                row.menge = row.uebernachtungen_anzahl;
                row.einheit = 'ÜN';
                row.faktor_einheit = 'gCO₂Äq/Ün';
            }
        }
    } else {
       // console.log('Datenqualitaet S49:', 'No Processing');
    }
    // console.log('Datenqualitaet', arr_datenqualitaet);
    // Übernachtungen nur im Subscope9
    if (co2_fussabdruck_ghg && +subscope === 9 && row.uebernachtungen === 'Ja' && row.uebernachtungen_anzahl > 0) {
        const personen = row.personen || 1; // Wenn z.B. leer, dann nehmen wir 1
        const faktor_ueb = getCO2AequivalentSubscope69_Unterkunft(data, jahr, row.unterkunft);

        const value_ueb = +row.uebernachtungen_anzahl * +faktor_ueb.wert * personen;
        row.value = (row.value || 0) + value_ueb;

        if (!row.faktor_map) {
            row.faktor_map = {};
            if (row.faktor && row.menge) {
                row.faktor_map[row.tid] = {
                    info: row.name,
                    menge: row.menge,
                    menge_einheit: row.einheit,
                    wert: row.faktor,
                    einheit: row.faktor_einheit,
                    quelle: row.quelle
                };
            }
        }
        row.faktor = null;
        row.faktor_einheit = 'gemischt';
        row.faktor_map['ÜN'] = {
            info: row.name,
            menge: +row.uebernachtungen_anzahl * personen,
            menge_einheit: 'ÜN',
            wert: +faktor_ueb.wert * 1000000,
            einheit: 'gCO₂Äq/ÜN',
            quelle: faktor_ueb.quelle
        };

        const unterkunft = getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'unterkunft', row.unterkunft);
        if (row.transportmittel === 'uebernachtung') {
            row.name = (row.name ? `${row.name} \n` : '') + `Nur Übernachtung \n${unterkunft}`;
        } else {
            row.name = (row.name ? `${row.name} \n` : '') + `Übernachtung: ${unterkunft}`;
        }

        if (!row.quelle) {
            row.quelle = faktor_ueb.quelle;
        } else if (row.quelle.indexOf(faktor_ueb.quelle) === -1) {
            row.quelle += ';;' + faktor_ueb.quelle;
        }
        arr_datenqualitaet.push({
            // wert: +row.menge,
            wert: value_ueb === 0 ? 0.01 : value_ueb,
            emissionsfaktor: +faktor_ueb.datenqualitaet,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
        // console.log('Unterkunft', unterkunft, faktor_ueb, arr_datenqualitaet);

    }

    if (co2_fussabdruck_ghg && +subscope === 9 && row.art) {
        if (row.name_veranstaltung) {
            row.name = row.name_veranstaltung + ': ' + row.name;
        } else {
            row.name = getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT, 'art', row.art) + '\n' + row.name;
        }
    }
    // console.log('SS' + subscope + ' Item', row);
    const key_items = `co2_fussabdruck_s3_ss${subscope}_items`;
    if (!item[key_items]) {
        item[key_items] = [];
    }
    // console.log('Datenqualitaet', arr_datenqualitaet);
    // Datenqualität setzen
    row.datenqualitaet = getDatenqualitaet(arr_datenqualitaet);
    // console.log('Subscope 49 arr_datenqualitaet', row.name, row.datenqualitaet, arr_datenqualitaet);

    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + row.value;
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);
    // console.log('SS49 - OUT: ', jahr, row.value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
}

export function processSubscope4mobil(row: any, data: any, item: any, jahr: number, arr: any[]) {
    // console.log('SS4 ROW', row);
    if (row.parent_tid && row.parent_tid > 0) {
        // Das ist eine Entfernungs-Row, also raus
        return;
    }
    row = { ...row };
    // Konfig
    const konfData: any[] = data[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;

    let value = 0;
    const subrows = arr.filter((sr: any) => sr.parent_tid === row.tid && sr.modus === row.modus && sr.art === row.art);
    const arr_datenqualitaet: any[] = [];

    // console.log('SS4 - MOB IN: ', jahr, row, subrows);
    let personen = 1;
    if (row.transportmittel_mobilitaet === 'bus' || row.transportmittel_mobilitaet === 'reisebus' ||
        row.transportmittel_mobilitaet === 'bahn' || row.transportmittel_mobilitaet === 'bahn_fern' ||
        row.transportmittel_mobilitaet === 'tram' || row.transportmittel_mobilitaet === 'flugzeug_international' ||
        row.transportmittel_mobilitaet === 'flugzeug_national') {
        personen = +row.personen || 1;
    }
    const fakt_hin_rueck = (+row.hin_rueck === 2 || +row.hin_rueck_orig === 2) ? 1 : 2;
    if (!modus || modus === '0' || !co2_fussabdruck_ghg || modus === 'distance_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            let menge = 0;
            const names: any = {};
            subrows.forEach((sr: any) => {
                let sr_personen = 1;
                let hasFaktorPersonen = false;
                if (sr.transportmittel_mobilitaet === 'bus' || sr.transportmittel_mobilitaet === 'reisebus' ||
                    sr.transportmittel_mobilitaet === 'bahn' || sr.transportmittel_mobilitaet === 'bahn_fern' ||
                    sr.transportmittel_mobilitaet === 'tram' || sr.transportmittel_mobilitaet === 'flugzeug_international' ||
                    sr.transportmittel_mobilitaet === 'flugzeug_national') {
                    sr_personen = +row.personen || 1;
                    hasFaktorPersonen = true;
                }
                let faktor_entf: any = {};
                let faktor_wert;
                let faktor_quelle;
                if (sr.transportmittel_mobilitaet === 'e_bike') {
                    // Scope 3.6 hat keinen E-Bike.
                    faktor_entf = getCO2AequivalentSubscope49(data, jahr, sr.transportmittel_mobilitaet, IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet');
                    faktor_wert = faktor_entf.wert_person || 0;
                    faktor_quelle = faktor_entf.quelle_person;
                } else {
                    faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, sr, 'transportmittel_mobilitaet');
                    faktor_wert = faktor_entf.wert || 0;
                    faktor_quelle = faktor_entf.quelle;
                }
                if (!faktor_entf.name) {
                    faktor_entf.name = getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet', sr.transportmittel_mobilitaet);
                }
                const entfernung = +sr.entfernung * fakt_hin_rueck * sr_personen;
                const value_entf = entfernung * faktor_wert;
                menge += entfernung;
                value += value_entf;
                let subname;
                if (sr.transportmittel_mobilitaet) {
                    subname = `${getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet', sr.transportmittel_mobilitaet)}${sr.kraftstoff_distance ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'kraftstoff_distance', sr.kraftstoff_distance)})` : ''}`;
                    names[subname] = true;
                }
                if (!row.quelle) {
                    row.quelle = faktor_quelle;
                } else if (row.quelle.indexOf(faktor_quelle) === -1) {
                    row.quelle += ';;' + faktor_quelle;
                }
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                row.faktor_map[faktor_entf.info] = {
                    info: subname,
                    menge: entfernung,
                    mengeOrig: +sr.entfernung,
                    menge_einheit: 'km',
                    menge_einheitOrig: 'km',
                    wert: faktor_wert * 1000000,
                    einheit: 'gCO₂Äq/km',
                    quelle: faktor_quelle,
                    formel_co2: hasFaktorPersonen ? 'co2_fahrt_personen' : 'co2_fahrt',
                    faktoren: [
                        {
                            value: fakt_hin_rueck,
                            type: KennzahlFaktor.TYPE_FAHRT,
                            formel: 'menge_fahrt'
                        },
                        ...(hasFaktorPersonen ? [
                            {
                                value: sr_personen,
                                type: KennzahlFaktor.TYPE_PERSONEN,
                                formel: 'menge_fahrt_personen'
                            }
                        ] : [])
                    ]
                };
                if(faktor_entf && (faktor_entf.datenqualitaet_distanz || faktor_entf.datenqualitaet_distanz === 0)) {
                    arr_datenqualitaet.push({
                        // wert: isMobilitaet ? +sr.personen : +sr.entfernung,
                        wert: value_entf, // hier Emission t CO2 Äq.
                        emissionsfaktor: +faktor_entf.datenqualitaet_distanz,
                        bewertung: +row.bewertung_emissionsfaktor,
                        datenherkunft: +row.datenherkunft,
                        faktor_entf
                    });
                }
            });
            row.name = Object.keys(names).join('\n');
            row.faktor_einheit = 'gemischt';
            row.value = value;
            row.menge = menge;
            row.einheit = 'km';
        } else {
            let faktor_entf: any = {};
            let faktor_wert;
            let faktor_quelle;
            if (row.transportmittel_mobilitaet === 'e_bike') {
                // Scope 3.6 hat keinen E-Bike.
                faktor_entf = getCO2AequivalentSubscope49(data, jahr, row.transportmittel_mobilitaet, IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet');
                faktor_wert = faktor_entf.wert_person || 0;
                faktor_quelle = faktor_entf.quelle_person;
            } else {
                faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, row, 'transportmittel_mobilitaet');
                faktor_wert = faktor_entf.wert;
                faktor_quelle = faktor_entf.quelle;
            }
            const value_entf = +row.entfernung * faktor_wert * fakt_hin_rueck * personen;
            console.log('SS4: ', value_entf, faktor_entf, row);
            value += value_entf;
            row.name = `${getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet', row.transportmittel_mobilitaet)}${row.kraftstoff_distance ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'kraftstoff_distance', row.kraftstoff_distance)})` : ''}`;
            row.faktor = faktor_wert * 1000000;
            row.faktor_einheit = 'gCO₂Äq/km';
            row.quelle = faktor_quelle;
            if(faktor_entf && (faktor_entf.datenqualitaet_distanz || faktor_entf.datenqualitaet_distanz === 0)) {
                arr_datenqualitaet.push({
                    // wert: isMobilitaet ? +sr.personen : +sr.entfernung,
                    wert: value_entf === 0 ? 0.1 : faktor_entf, // hier Emission t CO2 Äq.
                    emissionsfaktor: +faktor_entf.datenqualitaet_diszanz,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft
                });
            }
            row.menge = row.entfernung * fakt_hin_rueck * personen;
            row.einheit = 'km';
        }
    } else if (modus === 'spend_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            subrows.forEach((sr: any) => {
                const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, sr, 'transportmittel_mobilitaet');
                const value_spend = +sr.kosten * faktor_entf.wert_euro;
                if (row.value) {
                    row.value += value_spend; // * +row.menge;
                    row.kosten += +sr.kosten;
                } else {
                    row.value = value_spend; // * +row.menge;
                    row.kosten = +sr.kosten;
                }
                value += value_spend;
                if (sr.transportmittel_mobilitaet) {
                    names[getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet', sr.transportmittel_mobilitaet)] = true;
                }
                // console.log('SS4 subrow: ', jahr, faktor_entf, sr.kosten, row.value, row);
                if (!row.quelle) {
                    row.quelle = faktor_entf.quelle;
                } else
                    if (row.quelle.indexOf(faktor_entf.quelle) === -1) {
                        row.quelle += ';;' + faktor_entf.quelle;
                    }
                arr_datenqualitaet.push({
                    // wert: +sr.kosten,
                    wert: value_spend, // hier Emission t CO2 Äq.
                    emissionsfaktor: +faktor_entf.datenqualitaet_kosten,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft
                });
            });
            row.menge = row.kosten;
            row.faktor = (row.value / row.kosten) * 1000000;
            row.name = Object.keys(names).join('\n');
        } else {
            const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, row, 'transportmittel_mobilitaet');
            const value_euro = (+row.kosten || 0) * (faktor_entf.wert_euro || 0);
            // console.log('SS4SB:', faktor_entf);
            value = value_euro;
            row.menge = row.kosten;
            row.faktor = faktor_entf.wert_euro * 1000000;
            row.quelle = faktor_entf.quelle;
            row.name = getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'transportmittel_mobilitaet', row.transportmittel_mobilitaet);
            arr_datenqualitaet.push({
                // wert: +sr.kosten,
                wert: value_euro, // hier Emission t CO2 Äq.
                emissionsfaktor: +faktor_entf.datenqualitaet_kosten,
                bewertung: +row.bewertung_emissionsfaktor,
                datenherkunft: +row.datenherkunft
            });

        }
        row.einheit = '€';
        row.faktor_einheit = 'gCO₂Äq/€';
    } else if (modus === 'fuel_based') {
        if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
            const names: any = {};
            subrows.forEach((sr: any) => {
                const fuel_item = getDataForKraftstoff(sr, jahr, data);
                if (row.verbrauch) {
                    row.verbrauch += sr.verbrauch;
                    row.value += fuel_item.co2;
                } else {
                    row.verbrauch = sr.verbrauch;
                    row.value = fuel_item.co2;
                }
                names[sr.energietraeger_tid] = true;
                value += fuel_item.co2;
                if (!row.quelle) {
                    row.quelle = fuel_item.quelle;
                } else if (row.quelle.indexOf(fuel_item.quelle) === -1) {
                    row.quelle += ';;' + fuel_item.quelle;
                }
                arr_datenqualitaet.push({
                    // wert: +sr.verbrauch,
                    wert: fuel_item.co2, // hier Emission t CO2 Äq.
                    emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.bewertung_emissionsfaktor
                });
            });
            row.name = Object.keys(names).join('\n');
            // row.menge = row.verbrauch;
            row.einheit = 'siehe Dateneingabe';
            row.faktor_einheit = 'gemischt';
        } else {
            const fuel_item = getDataForKraftstoff(row, jahr, data);
            row.name = row.energietraeger_tid;
            value = fuel_item.co2;
            row.menge = row.verbrauch;
            row.einheit = row.verbrauch ? fuel_item.einheit : '';
            row.faktor = fuel_item.faktor_co2 * 1000000;
            row.quelle = fuel_item.quelle_co2;
            row.faktor_einheit = 'gCO₂Äq/' + fuel_item.einheit;
            arr_datenqualitaet.push({
                // wert: +sr.verbrauch,
                wert: fuel_item.co2, // hier Emission t CO2 Äq.
                emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                datenherkunft: +row.datenherkunft,
                bewertung: +row.bewertung_emissionsfaktor
            });
        }
    }

    if (row.uebernachtungen === 'Ja' && row.reiseland && row.uebernachtungen_anzahl > 0) {
        const personen_ueb = row.teilnehmer || 1;
        let faktor_ueb = getCO2AequivalentSubscope6_Uebernachtung(data, jahr, row.reiseland);
        let value_ueb = +row.uebernachtungen_anzahl * +faktor_ueb.wert * personen_ueb;
        // console.log('ÜN: ', faktor_ueb, value_ueb);
        if (row.reiseland === 'deutschland') {
            const faktor_unt = getCO2AequivalentSubscope69_Unterkunft(data, jahr, row.unterkunft);
            // console.log('ÜN 2: ', faktor_ueb, value_ueb);
            if (faktor_unt) {
                value_ueb = +row.uebernachtungen_anzahl * +faktor_unt.wert * personen_ueb;
                faktor_ueb = faktor_unt;
            }
        }
        value += value_ueb;
        row.name += faktor_ueb.name ? `(${faktor_ueb.name})` : '';

        if (!row.faktor_map) {
            row.faktor_map = {};
            if (row.faktor && row.menge) {
                row.faktor_map[row.tid] = {
                    info: row.name,
                    menge: row.menge,
                    menge_einheit: row.einheit,
                    wert: row.faktor,
                    einheit: row.faktor_einheit,
                    quelle: row.quelle
                };
            }
        }
        row.faktor = null;
        row.faktor_einheit = 'gemischt';
        row.faktor_map['ÜN'] = {
            info: 'Übernachtungen',
            menge: +row.uebernachtungen_anzahl * personen_ueb,
            menge_einheit: 'ÜN',
            wert: +faktor_ueb.wert * 1000000,
            einheit: 'gCO₂Äq/ÜN',
            quelle: faktor_ueb.quelle
        };

        const unterkunft = getStaticOption(IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, 'unterkunft', row.unterkunft);
        if (row.transportmittel_mobilitaet === 'uebernachtung') {
            row.name += `\n${unterkunft}`;
        } else {
            row.name += `\nÜbernachtung: ${unterkunft}`;;
        }

        if (!row.quelle) {
            row.quelle = faktor_ueb.quelle;
        } else if (row.quelle.indexOf(faktor_ueb.quelle) === -1) {
            row.quelle += ';;' + faktor_ueb.quelle;
        }
        arr_datenqualitaet.push({
            wert: value_ueb,
            emissionsfaktor: +faktor_ueb.datenqualitaet,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
    }
    const key_wert = 'co2_fussabdruck_s3_ss4_wert';
    const key_items = 'co2_fussabdruck_s3_ss4_items';
    if (!item[key_items]) {
        item[key_items] = [];
    }
    if (row.lieferant_tid) {
        row.name = row.lieferant_tid + ' / ' + row.name;
    }
    row.value = value;

    // Datenqualität setzen
    row.datenqualitaet = getDatenqualitaet(arr_datenqualitaet);
    // console.log('ÜN 3', row);

    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + (row.value || 0);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);
}
